module.exports = __webpack_public_path__ + "static/img/smartphone-image.aeb6128.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartphone-image.webp
// module id = yA8r
// module chunks = 1